export default __webpack_public_path__ + "static/media/India–US-Trade-Deal-Major-Win-For-Indian-Textiles.3f65b579.png";